module.exports = __webpack_public_path__ + "47a313e68b3bc7d4c3cdacb4047a9fd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/fluorescence_diamond_ring@2x.png
// module id = 866
// module chunks = 0